import logic from "./logic";

export default [...logic];
